import { render, staticRenderFns } from "./ContestPlayerRewards.vue?vue&type=template&id=85ec98fe&"
import script from "./ContestPlayerRewards.vue?vue&type=script&lang=js&"
export * from "./ContestPlayerRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports